module.exports = __webpack_public_path__ + "static/media/calendario.43f69d10.png";